export default "__VITE_ASSET__29da4e1c__"